import {
  ARQUEOS_REQUEST, ARQUEOS_SUCCESS, ARQUEOS_FAILURE,
  GENERATED_SALES_ARQUEOS_REQUEST, GENERATED_SALES_ARQUEOS_SUCCESS, GENERATED_SALES_ARQUEOS_FAILURE
} from '../actions/arqueos'

const INITIAL_STATE = {
  arqueos: null, arqueo: null, arqueosNeedRefresh: false,
  generatedSalesArqueos: null, generatedSalesLoading: false, generatedSalesError: null,
  error: null, loading: false
}

const arqueosReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case ARQUEOS_REQUEST:
        return { ...state, arqueosNeedRefresh: false, error: null, loading: true }
      case ARQUEOS_SUCCESS:
        return { ...state, arqueosNeedRefresh: false, arqueos: action.response, error: null, loading: false }
      case ARQUEOS_FAILURE:
        return { ...state, error: action.error, loading: false }

      case GENERATED_SALES_ARQUEOS_REQUEST:
        return { ...state, generatedSalesLoading: true, generatedSalesError: null }
      case GENERATED_SALES_ARQUEOS_SUCCESS:
        return { ...state, generatedSalesLoading: false, generatedSalesArqueos: action.response }
      case GENERATED_SALES_ARQUEOS_FAILURE:
        return { ...state, generatedSalesLoading: false, generatedSalesError: action.error }

      default:
        return state
    }
  }

export default arqueosReducer

